<template>
    <div style="background-color: #f2f2f2;height: 100%;" class="InstitutionArg">
        <div style="background-color: #fff;padding:0px 20px; line-height: 50px;border-bottom: 1px solid #ddd;">
            固定费用设置
        </div>
        <div style="padding: 20px;"> 

            <div>

                <el-row>
                    <!-- <el-button type="primary" @click.native="toggleModalAdd">添加</el-button> -->
                    <el-button type="success" :disabled="disabledEdit"  @click="toggleModalEdit">编辑</el-button>
                </el-row>
                <div style="clear: both;"></div>
            </div>

            <div style="height: 10px;"></div>

            <div>
                <template>
                    <el-table
                    :data="tableData"
                    border
                    :height="th"
                    v-loading="loading"
                    highlight-current-row 
                    @row-click='rowClick'
                    style="width: 100%">
                    <el-table-column
                        prop="institution.name"
                        label="机构名称"
                        >
                    </el-table-column>
                    <el-table-column
                        prop="fixedFee"
                        label="固定费用(一次性收费)"
                        >
                    </el-table-column>
                    </el-table>
                </template>
            </div>
        </div>
        <!-- <Add ref="myAdd" v-show="showModalAdd" v-on:closeAdd="closeAdd" v-on:getList="getList"></Add> -->
        <Edit ref="myEdit" v-show="showModalEdit" v-on:closeEdit="closeEdit" v-on:getList="getList"></Edit>
    </div>
</template>

<script>

    import {timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";

    //import Add from "./Add";
    import Edit from "./Edit";
    import {getStaffCode,getMenuButton} from "@/utils/auth";

    export default {
        name: "Role",
        data(){
            return{
                loading:true,
                menuButtonList:null,
                th:0,
                row:null,
                showModalAdd:false,
                showModalInfo:false,
                showModalEdit:false,
                disabledEdit:true,
                tableData:null,
            }
        },
        components:{
            Edit
        },
        created(){
            this.getList();
            this.getMenu();
            this.th = this.$store.state.tableHeight;
        },

        watch: {
            //监听全局变量
            '$store.state.tableHeight' : function(val){
                this.th = val;
            },
        },
        methods:{
             
            toggleModalAdd:function(){
                this.$refs.myAdd.init();
                this.showModalAdd = !this.showModalAdd;
            },
            closeAdd:function(){
                this.showModalAdd = !this.showModalAdd;
            },
            getMenu(){
                let list = JSON.parse(window.localStorage.getItem("listMenuDTO"));
                var menu = getMenuButton(list,this.$route.path);
                this.menuButtonList = JSON.stringify(menu);
                // if(menu!=null&&menu.length>0){
                //     for(let i=0;i<menu.length;i++){
                //         if(menu[i].buttonName=="添加"){
                //             this.disabledAdd = false;
                //         }
                //     }
                // }
            },
            getList(){
                this.loading = true;
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+"InstitutionArg/GetInstitutionArg",
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                    }
                }).then( (response)=> {
                    this.loading = false;
                    this.disabledEdit=true;
                    if(response.data.error == 0){
                        console.log(response.data.data);
                        this.tableData = response.data.data;
                    }else if(response.data.error == 1){
                        this.$message({type: 'info', message: response.data.message});
                    }
                }).catch(function (error) {
                    console.log(error);
                });
            },
            toggleModalEdit(){
                this.showModalEdit = !this.showModalEdit;
                this.$refs.myEdit.init(this.row);
            },
            closeEdit:function(){
                this.showModalEdit = !this.showModalEdit;
            },
            rowClick(row){
                 this.row = row;
                if(this.menuButtonList.indexOf("编辑")!=-1){
                    this.disabledEdit =false;
                }
            }



        }
    }
</script>

<style lang="scss" scoped>
    /deep/ .el-table__body tr.current-row>td {
        background-color: #409EFF;
        color:#fff;
    }
</style>
